import script from "./CreatorDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorDashboard.vue?vue&type=script&setup=true&lang=js"

import "./CreatorDashboard.vue?vue&type=style&index=0&id=047c3903&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047c3903"]])

export default __exports__